import type { GetTaskListRequest } from '@/domains/task/apis/task-api';

/**
 * 创建任务请求
 */
export interface ApiCreateTaskRequest<T> {
    /**
     * 任务 ID
     */
    task_id: string;
    /**
     * 任务类型
     */
    type: GetTaskListRequest['type'];
    /**
     * 任务内容
     */
    content: T;
}

export const CreateTask = Symbol('CreateTask');

/**
 * 创建任务
 */
export interface CreateTask<T> {
    createTask(data: ApiCreateTaskRequest<T>): Promise<void>;
}
